import React, {useEffect} from 'react';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import css from './Section.module.scss';
import {useScrollService} from '../ScrollService';
import {SECTION_TYPES} from './SectionTypes';
import {useLocation} from 'react-router';

export const Section: React.FC<{
  title: string;
  children: any;
  number: number;
  type: SECTION_TYPES;
}> = ({title, children, number, type}) => {
  const [isHidden, setIsHidden] = React.useState(true);
  const ref = React.useRef<HTMLDivElement>(null);
  const location = useLocation();

  const scroller = useScrollService();

  useEffect(() => {
    if (location.search.includes(type)) {
      setIsHidden(false);
      setImmediate(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
      });
    }
  }, [location, type, ref]);

  let down = (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.0625 0.96875L0 2.03125L5 7.03125L10 2.03125L8.9375 0.96875L5 4.90625L1.0625 0.96875Z"
        fill="white"
      />
    </svg>
  );

  let up = (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.0625 7.03125L0 5.96875L5 0.96875L10 5.96875L8.9375 7.03125L5 3.09375L1.0625 7.03125Z"
        fill="white"
      />
    </svg>
  );

  const action = () => {
    if (isHidden) {
      scroller.current.scroll(type);
    }
    setIsHidden(!isHidden);
  };

  return (
    <div className={css.section} ref={ref}>
      <div className={css.header}>
        <div className={css.title} onClick={action}>
          <div className={css.number}>{number}</div>
          <div>{title}</div>
        </div>
        <ButtonV2 type="secondary" onClick={action}>
          {isHidden ? down : up}
        </ButtonV2>
      </div>
      {!isHidden && <div className={css.content}>{children}</div>}
    </div>
  );
};
